export const toMMHH = (seconds: number): string =>
    new Date(seconds * 1000).toISOString().substr(14, 5)
